<template>
  <div ref="headerContent" class="header-content">
    <div class="collapse-btn" @click="handleCollapse">
      <i :class="['iconfont', isCollapse ? 'el-icon-vector-unfold' : 'el-icon-vector-fold ']"></i>
    </div>
    <div class="dropdown-btn" @hover="handleHover">
      <el-button type="text" @click="dropDownMenu"
        >{{ $t('main_header_IT_system') }}
        <i :class="['el-icon--right', isDropDown ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"></i
      ></el-button>
    </div>
    <div class="operation-group">
      <div class="item user-info">
        <!-- <div class="search-box">
          <el-input
            clearable
            :placeholder="$t('main_header_placeholder')"
          ></el-input>
          <el-icon class="searchSvn"><Search /></el-icon>
        </div> -->
        <el-dropdown
          @command="changeLanguage"
          popper-class="lang-dropdown"
          trigger="hover"
          size="default"
        >
          <div class="lang-wrapper">
            <span class="lang-title">
              {{ getLangTitle() }}
            </span>
            <span class="arrow-down" />
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :command="key" v-for="(item, key) in langTextMap" :key="key">
                {{ item }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <!-- <el-tooltip effect="dark" :content="$t('main_header_todo_center')" placement="bottom">
          <el-button class="todo-icon" type="text" size="medium" @click="gotoTodoPage">
            <el-icon><FolderChecked /></el-icon>
          </el-button>
        </el-tooltip>
        <el-tooltip effect="dark" :content="$t('main_header_message_remind')" placement="bottom">
          <el-button class="notice-icon" type="text" size="medium" @click="gotoMesPage">
            <img src="../../assets/notification_icon.png" />
          </el-button>
        </el-tooltip> -->

        <!-- 下载中心 -->
        <DownCenter />

        <!-- 导出菜单权限excel -->
        <ExportMenu />

        <el-tooltip effect="dark" :content="$t('main_menu_view_permission')" placement="bottom">
          <el-button class="public-icon" type="text" size="medium" @click="handleViewPermissions">
            <i class="el-icon-view public-icon-i"></i>
          </el-button>
        </el-tooltip>

        <el-tooltip effect="dark" :content="$t('main_header_full_screen')" placement="bottom">
          <el-button class="public-icon" type="text" size="medium" @click="handleFullScreen">
            <!-- <div class="flex row vcenter"> -->
            <i class="el-icon-full-screen public-icon-i"></i>
            <!-- <span>全屏</span> -->
            <!-- </div> -->
          </el-button>
        </el-tooltip>
        <!-- 强刷新按钮 -->
        <el-tooltip effect="dark" :content="$t('main_header_forced_refresh')" placement="bottom">
          <el-button class="public-icon" type="text" size="medium" @click="handleForcedRefresh">
            <!-- <div class="flex row vcenter"> -->
            <i class="el-icon-refresh public-icon-i"></i>
            <!-- <span>刷新</span> -->
            <!-- </div> -->
          </el-button>
        </el-tooltip>

        <!-- <el-avatar class="avatar" size="small" icon="el-icon-s-custom"> </el-avatar> -->
        <img class="avatar" src="../../assets/avatar.png" />
        <el-popover placement="bottom" :width="80" trigger="hover" ref="loginPopper">
          <div @click.capture="handleCapture">
            <el-button style="width: 100%" type="text" @click="changePassword">
              {{ $t('main_header_change_SYS_password') }}
            </el-button>
            <el-divider style="margin: 10px 0"></el-divider>
            <el-button type="primary" style="width: 100%" @click="handleLogout">{{
              $t('main_header_log_out')
            }}</el-button>
          </div>
          <template #reference>
            <el-button type="text">
              <span class="userInfo-name">{{ store.state.user.userInfo?.name }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
          </template>
        </el-popover>
      </div>
    </div>
  </div>
  <AllMenu :isShow="isDropDown" @close="handleClose" />
  <ChangePassword :visible="changePasswordVisible" @cancel="changePasswordVisible = false" />
  <XMind
    v-model:visible="xMindState.visible"
    :title="$t('main_menu_view_permission')"
    :data="xMindState.data"
  />
</template>

<script>
import { defineComponent, inject, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import AllMenu from './AllMenu.vue'
import ChangePassword from './ChangePassword.vue'
import XMind from './XMind.vue'
import ExportMenu from './ExportMenu.vue'
import DownCenter from './DownCenter.vue'
import { langTextMap, getLanguage, setLanguage, $t, setDocumentTitle } from '@/lang/index'
// import { FolderChecked, Search } from '@element-plus/icons-vue'
import { getUserMenuList } from '@/services/user'
import { SAVE_STORAGE_LIST } from './constants'

export default defineComponent({
  name: 'ContainerHeader',
  components: {
    AllMenu,
    ChangePassword,
    XMind,
    ExportMenu,
    DownCenter
    // FolderChecked
    // Search
  },
  emits: ['isCollapseChange'],
  setup(props, { emit }) {
    const store = useStore()
    const router = useRouter()
    const reloadView = inject('reloadView')
    // const userInfo = store.state.user.userInfo
    // watch(store.state.user, (user) => {
    //   console.log(user.userWaitProcessNum)
    // }, { immediate: true })
    const isCollapse = ref(false)

    const xMindState = ref({
      visible: false,
      data: {}
    })

    const handleCollapse = () => {
      isCollapse.value = !isCollapse.value
      emit('isCollapseChange', isCollapse.value)
    }
    const handleLogout = () => {
      ElMessageBox.confirm($t('main_header_log_out_tip'), $t('main_header_log_out_title'), {
        confirmButtonText: $t('main_header_confirm'),
        cancelButtonText: $t('main_header_cancel'),
        type: 'warning'
      })
        .then(() => {
          store.commit('menu/resetTab')
          store.commit('menu/changeCurrentMenu', '')
          store.commit('user/setUserInfo', null)
          store.commit('env/setAmsConfig', null)

          // 获取退出不需要删除的本地存储数据
          const excludeClearItem = {}
          SAVE_STORAGE_LIST.forEach(item => {
            const itemValue = localStorage.getItem(item)
            if (itemValue) {
              excludeClearItem[item] = itemValue
            }
          })

          localStorage.clear()

          // 清空后，将保留的数据重新写入本地存储
          for (const key in excludeClearItem) {
            localStorage.setItem(key, excludeClearItem[key])
          }

          setTimeout(() => {
            store.commit('user/removeFormCache')
          }, 300)
          router.push('/login')
        })
        .catch(err => {
          console.log(err)
        })
    }

    const isDropDown = ref(false)
    const handleClose = () => {
      isDropDown.value = false
      setTimeout(() => {
        headerContent.value.style['z-index'] = 0
      }, 500)
    }

    const headerContent = ref(null)
    const dropDownMenu = () => {
      if (!isDropDown.value) {
        headerContent.value.style['z-index'] = 2000
      }
      isDropDown.value = !isDropDown.value
    }

    const changePasswordVisible = ref(false)

    const loginPopper = ref(null)
    const handleCapture = () => {
      loginPopper.value.hide()
    }
    // const gotoTodoPage = () => {
    //   router.push('/portal/center/workbench-front/todo-center')
    // }
    // const gotoMesPage = () => {
    //   router.push('/portal/center/workbench-front/message')
    // }

    // 点击全屏按钮回调
    const handleFullScreen = () => {
      try {
        console.log('点击全屏------')
        if (!document.fullscreenElement) {
          // 进入全屏
          document.documentElement.requestFullscreen().catch(err => {
            console.error(`全屏错误: ${err.message}`)
          })
        } else if (document.exitFullscreen) {
          // 退出全屏
          document.exitFullscreen()
        }
      } catch (error) {
        console.log(error)
      }
    }
    // 抽取的公共菜单操作函数
    const updateMenuList = () => {
      return getUserMenuList()
        .then(res => {
          store.commit('menu/setMenuList', res.data.menuList)
          store.commit('menu/setPageList', res.data.pageList)
          setDocumentTitle()
        })
        .catch(error => {
          store.commit('user/setUserInfo', null)
          console.log(error)
          throw error
        })
    }

    // 点击强制刷新按钮回调
    const handleForcedRefresh = () => {
      try {
        // 在刷新前重新获取菜单
        store.commit('menu/changeMenuLoading', true)
        updateMenuList().finally(() => {
          // 实现整个页面刷新缓存重新加载
          location.reload()
          store.commit('menu/changeMenuLoading', false)
        })
      } catch (error) {
        console.log(error)
      }
    }

    // 切换语言
    const changeLanguage = val => {
      setLanguage(val)
      store.commit('menu/changeMenuLoading', true)
      updateMenuList().finally(() => {
        reloadView()
        store.commit('menu/changeMenuLoading', false)
      })
    }
    // 获取当前语言text
    const getLangTitle = () => {
      return langTextMap[getLanguage()]
    }

    const changePassword = () => {
      // 根据开关配置切换平台
      // if (store.state.env.amsConfig?.UserSourceSwitch) {
      //   // 在新窗口中打开链接
      //   window.open(store.state.env.amsConfig?.UpdatePasswordLink)
      // } else {
      //   changePasswordVisible.value = true
      // }
      window.open(
        store.state.env.amsConfig?.UpdatePasswordLink ??
          'https://ams-public.ztn.cn/v4/outer-update-password-detail'
      )
    }

    const handleViewPermissions = () => {
      xMindState.value.visible = true
      const menu = formartMenu(store.state.menu.menuList)
      xMindState.value.data = {
        topic: 'Portal',
        id: 'root',
        children: menu
      }
    }

    const formartMenu = menu => {
      const menuList = menu.map(item => {
        const menuItem = {
          ...item,
          topic: item.menuName,
          id: item.menuId.toString(),
          children: []
        }
        if ((item.childMenuList?.length ?? 0) > 0) {
          menuItem.children = formartMenu(item.childMenuList)
        }
        return menuItem
      })
      return menuList
    }

    return {
      loginPopper,
      isCollapse,
      handleCollapse,
      handleFullScreen,
      handleForcedRefresh,
      // userInfo,
      store,
      // gotoTodoPage,
      // gotoMesPage,
      handleLogout,
      dropDownMenu,
      isDropDown,
      handleClose,
      headerContent,
      changePasswordVisible,
      handleCapture,
      getLangTitle,
      changeLanguage,
      langTextMap,
      changePassword,
      xMindState,
      handleViewPermissions
    }
  }
})
</script>

<style lang="scss" scoped>
.header-content {
  position: relative;
  background-color: #ffffff;
  height: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.collapse-btn {
  width: 50px;
  height: 100%;
  color: #323232;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dropdown-btn {
  width: 97px;
  text-align: center;

  .el-button--text {
    // color: $text-color !important;
    font-weight: 400;
    font-size: 13px;
    color: #808080 !important;
  }
  .el-icon--right {
    margin-left: 10px;
    color: #808080;
  }
}

.operation-group {
  margin-left: auto;
  margin-right: 20px;
  .item {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .user-info {
    .avatar {
      margin-left: 25px;
      margin-right: 6px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
    }

    .el-button--text {
      color: $title-color !important;
    }

    // .todo-icon {
    //   margin-left: 25px;

    //   .el-icon {
    //     color: #323232;
    //     font-size: 22px;
    //     font-weight: bolder;
    //   }
    // }

    :deep(.public-icon) {
      margin-left: 25px;

      .el-icon {
        color: #323232;
        font-size: 22px;
        font-weight: bolder;
      }
    }

    :deep(.public-icon-i) {
      font-size: 18px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.8) !important;
    }

    // .notice-icon {
    //   cursor: pointer;
    //   margin-left: 25px;
    //   img {
    //     width: 22px;
    //     height: 24px;
    //   }
    //   &:hover {
    //     animation: swing 2.5s linear 0.15s infinite;
    //   }
    // }

    .userInfo-name {
      font-weight: 400;
      font-size: 13px;
      color: #323232;
    }

    .el-icon--right {
      font-size: 13px;
      color: #323232;
      margin-left: 6px;
    }

    .search-box {
      margin-right: 30px;
      box-sizing: border-box;
      width: 200px;
      position: relative;

      .el-input {
        box-sizing: border-box;
      }

      :deep(.el-input__inner) {
        border-radius: 38px;
        height: 38px;
        background-color: #f0f0f0;
        border: none;
        font-size: 12px;
        padding: 0 24px;
      }

      :deep(.el-input__suffix) {
        right: 16px;
        top: 4px;
      }

      .searchSvn {
        position: absolute;
        right: 20px;
        top: 12px;
        color: #808080;
        cursor: pointer;
      }
    }
  }
  .lang-wrapper {
    display: flex;
    align-items: center;
    cursor: pointer;
    // margin-right: 10px;
    .lang-title {
      height: 18px;
      line-height: 18px;
      color: #333333;
      font-size: 14px;
    }
    .arrow-down {
      width: 0;
      height: 0;
      border: 5px solid transparent;
      border-top: 5px solid #bdbdbd;
      margin-top: 7px;
      margin-left: 6px;
    }
  }
}
.lang-dropdown {
  .el-dropdown-menu {
    .el-dropdown-menu__item:focus,
    .el-dropdown-menu__item:not(.is-disabled):hover {
      background-color: #e7f3f3;
      color: #3d9d9d;
    }
  }
}

.el-icon-view:before {
  content: '\e6ce' !important;
}

.el-icon-vector-fold:before {
  font-family: 'iconfont' !important;
  content: '\e611' !important;
}

@keyframes swing {
  10% {
    transform: rotate(15deg);
  }
  20% {
    transform: rotate(-10deg);
  }
  30% {
    transform: rotate(5deg);
  }
  40% {
    transform: rotate(-5deg);
  }
  50%,
  100% {
    transform: rotate(0deg);
  }
}
</style>
